import { render } from "./GifPlayPause.vue?vue&type=template&id=b08011f8&scoped=true&ts=true"
import script from "./GifPlayPause.vue?vue&type=script&lang=ts"
export * from "./GifPlayPause.vue?vue&type=script&lang=ts"

import "./GifPlayPause.vue?vue&type=style&index=0&id=b08011f8&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b08011f8"]])

export default __exports__